
<template>
  <div class="topalert" v-if="notLoading">

    <div class="top-innerbox" v-for="(item, index) in this.$store.state.topAlert" :key="item.index" :style="{
      'background-color':
        index == 0 ? '#97cc52' : index == 1 ? '#a7d045' : '#bad649',
    }">

      <transition name="bounce">
        <div class="alertbox" v-if="!item.check" :class="{ zh: $i18n.locale == 'zh' }">
          <div class="ask-image"></div>
          <div class="alert-message">
            <p class="alert-title">
              {{ item.title.rendered }}
            </p>
            <p class="alert-container" v-html="item.content.rendered">

            </p>
          </div>
          <div class="alert-close">

            <img @click="closeTopAlert($event, item)" src="../assets/images/close.svg" alt="" />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
 
<script>
//此页为通用页头
export default {
  name: "app-topalert",
  data() {
    return {
      showCard: false,
      notLoading: true,
      topalert: [

      ],
    };
  },
  watch: {
    '$i18n.locale'(oldval, newval) {
      this.notLoading = false
    },
    // 'i18n.locale'(){

    // }
  },
  methods: {
    getCookie(name) {
      var strcookie = document.cookie.replaceAll('result_code=;', ''); //获取cookie字符串
      console.log(document.cookie);
      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return "";
    },

    closeTopAlert(el, item) {
      console.log(el.target.parentNode.parentNode);
      el.target.parentNode.parentNode.addEventListener('transitionstart', () => {
        console.log('transition 开始');
      });
      el.target.parentNode.parentNode.style.maxHeight = el.target.parentNode.parentNode.clientHeight + 'px'
      console.log(el.target.parentNode.parentNode.style.maxHeight);
      setTimeout(() => {
        el.target.parentNode.parentNode.style.maxHeight = '0';
      }, 1);
      document.cookie = "top_alert_id=" + this.getCookie('top_alert_id') + ',' + item.date + ';path = /';
      item.check = true;
    },
  },
  created() {
    //   localStorage.setItem('myCat', 'Tom'); 设置缓存
    console.log(localStorage);
  },
};
</script>
<style lang="scss" scoped>
p::v-deep a {
  display: contents;
  color: #ffe95c;
  font-family: 'MohrRounded Black', HYZhengYuan-65W, Microsoft YaHei, sans-serif;
}

@import "../assets/scss/topalert.scss";
</style>